import { defineFurniture } from './types.js';
import type { FurnitureDef } from './types.js';

/**
 * A running track and everything else to build a stadium scene: bleachers,
 * floodlights, a scoreboard, a finish line, starting blocks, an entrance
 * arch, a winners' podium and corner flags. Category 'stadium'.
 */
export const STADIUM_FURNITURE: Record<string, FurnitureDef> = defineFurniture('stadium', {
  running_track_straight: {
    label: 'Running Track (Straight)',
    description: 'A lane of real rubberised running track. Lay a few end to end.',
    price: 45,
    solid: false,
    height: 0,
  },
  running_track_corner: {
    label: 'Running Track (Corner)',
    description: 'Bends the running track 90°. Rotate to match your course.',
    price: 45,
    solid: false,
    height: 0,
  },
  stadium_bleacher: {
    label: 'Bleacher Stand',
    description: 'Tiered seating for spectators to cheer from.',
    price: 320,
    solid: true,
    height: 1.6,
  },
  stadium_floodlight: {
    label: 'Stadium Floodlight',
    description: 'Lights up the track for an evening race.',
    price: 260,
    solid: true,
    height: 2.1,
  },
  stadium_scoreboard: {
    label: 'Scoreboard',
    description: 'Keeps score, or just looks official.',
    price: 400,
    solid: true,
    height: 1.7,
  },
  finish_line_banner: {
    label: 'Finish Line',
    description: 'A checkered banner to dash through.',
    price: 140,
    solid: false,
    height: 1.1,
  },
  starting_blocks: {
    label: 'Starting Blocks',
    description: 'On your marks, get set, go!',
    price: 70,
    solid: false,
    height: 0.15,
  },
  stadium_arch: {
    label: 'Stadium Arch',
    description: 'A grand entrance for the big race day.',
    price: 480,
    solid: true,
    height: 2.4,
  },
  winners_podium: {
    label: "Winners' Podium",
    description: '1st, 2nd and 3rd place, all in a row.',
    price: 220,
    solid: true,
    height: 0.9,
  },
  stadium_flag: {
    label: 'Track Flag',
    description: 'Marks a corner in style.',
    price: 55,
    solid: false,
    height: 1.0,
  },
});
